(function deviceCapabilites(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  if (!global.NewHomeSource.Modules.IdleQueue &&
    !global.NewHomeSource.WebStorageHandler) {
    return;
  }

  const eventsQueue = new global.NewHomeSource.Modules.IdleQueue();
  let formats = {};

  /**
   * @private
   * canUseWebP: check if we can use WebP in NHS.
   *
   */
  function canUseWebP() {
    const elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
      return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    return false;
  }

  /**
   * @private
   * setAcceptTypeMimesType: set in localstorage the mime types supported by the browser.
   *
   */
  function setAcceptTypeMimesType() {
    const supportedFormats = [];
    Object.keys(formats).forEach((key) => {
      const format = formats[key];
      if (format.verifyFormat()) {
        supportedFormats.push(format.mimeType);
      }
    });

    global.localStorage.setItem('browserAcceptTypes', supportedFormats.join(','));
    return true;
  }

  formats = {
    webP:
    {
      mimeType: 'image/webp',
      verifyFormat: canUseWebP
    }
  };

  eventsQueue.pushTask(setAcceptTypeMimesType);
}(window));
